import { useContext } from 'react';
import { GlobalContext } from '../providers/GlobalProvider';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(GlobalContext);